import * as React from 'react';

function SvgClockCircle(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 1a7 7 0 10.001 14.001A7 7 0 008 1zm2.758 9.152l-.447.609a.123.123 0 01-.082.05.124.124 0 01-.093-.024L7.552 8.903a.124.124 0 01-.052-.101V4.5c0-.069.056-.125.125-.125h.752c.068 0 .125.056.125.125v3.867l2.228 1.611c.056.04.068.117.028.174z"
        fill="#F9A600"
      />
    </svg>
  );
}

export default SvgClockCircle;
